import NBType, { InferType } from '@netbase/nb-type'

const PostSchema = NBType.object().shape('PostSchema', {
  /* @prop */
  domain: NBType.string(),
  /* @prop */
  postID: NBType.string()
  /* END */
})
export default PostSchema
export type Post = InferType<typeof PostSchema>
// RESERVE BELOW
